import {EcommerceAction} from "./../../models/EcommerceAction";

let ecommerceActionsApi = {
    async get(clientId, token, companyId, params=[], select= [], relations=['product.prices', 'deal.campaign', 'deal.url', 'deal.fieldsOptions.field']){
        let response = await window.axios.get('/api/ecommerce-actions', {
            params:{
                api_token:token,
                company_logged:companyId,
                client_id:clientId,
                select:select,
                relationships:relations,
                ...params
            }
        });
        return response.data.map(e=>new EcommerceAction(e));
    },
}

export default ecommerceActionsApi